
import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import NavMenu from "../../molecules/nav-menu/navMenu"
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities"
import "./nav.scss"

interface NavInterface {
   isMenuActive:boolean,
   isSearcherActive:boolean,
   isDark: boolean;
   actionTheme: () => void;
}

const Nav = ( { isMenuActive, isSearcherActive, isDark, actionTheme }: NavInterface) => {
	const data = useStaticQuery(graphql`
		query MENU_SIDE_OPTIONS {
			allContentfulMenuCategorias(filter: {titulo: {eq: "Menu comfama.com"}}) {
				nodes {
					iconosLaterales {
						slug
						hyperLink
						nombreCategoria
						imagenDestacada {
							description
							file {
								url
							}
						}
					}
				}
			}
		}
	`)

   const { iconosLaterales } = data.allContentfulMenuCategorias.nodes[0]
   
	return (
		<div className='o-nav'>
			<section className='o-nav__bar'>
				<ul className='o-nav__bar-links hide-on-mobile'>
					{ iconosLaterales && iconosLaterales.map((item, i)=>(
						<li key={`link${i}`}>
							<a  className= { `gtmMenuTrans${normalizeTwoWords(item.nombreCategoria)}` }
								href={ item.hyperLink ? item.hyperLink:item.slug } 
                        target={ item.hyperLink ? '_blank' : '_self' }
                        rel={ item.hyperLink ? "nofollow noreferrer" : 'follow'}
                        >
								<img  
									className= { `gtmMenuTrans${normalizeTwoWords(item.nombreCategoria)}` }
									src={item.imagenDestacada[0].file.url} 
									alt={item.imagenDestacada[0].description}
								/>
							</a>
							<span className='o-nav__bar-tooltip'> {item.nombreCategoria} </span>
						</li>
					))}
				</ul>
			</section>

			<NavMenu
				isMenuActive={ isMenuActive }
				isSearcherActive={ isSearcherActive }
            sideLinks= { iconosLaterales }
            isDark={isDark}
            actionTheme={actionTheme}
			/>
			
		</div>
)}


export default Nav
